// extracted by mini-css-extract-plugin
export default {"price":"V4-z","priceRow":"W4-z","onSale":"X4-z","msrpLabelPrice":"Y4-z","msrpLabel":"Z4-z","originalPrice":"_4-z","percentOff":"a5-z"};